/**
 * @generated SignedSource<<b0b05941969a0c6a3dd768f0c508ecf6>>
 * @relayHash 174f010b2a350d23b5ceaacd7ab225f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a274c95e5cb081e24500c5bedb48bc018cc724673947ee23ad2809b113ee93ee

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type YourAgentResultsQuery$variables = {
  cloudId: string;
  product?: string | null;
};
export type YourAgentResultsQuery$data = {
  readonly ownedAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
      } | null;
    }>;
  } | null;
  readonly starredAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
      } | null;
    }>;
  } | null;
};
export type YourAgentResultsQuery = {
  response: YourAgentResultsQuery$data;
  variables: YourAgentResultsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyMyAgents": true
    }
  },
  (v2/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "AgentCardRelay_StudioBrowseKit"
          }
        ]
      }
    ]
  }
],
v6 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "input",
    "value": {
      "onlyFavouriteAgents": true
    }
  },
  (v2/*: any*/)
],
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  {
    "concreteType": "AgentStudioAgentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "AgentStudioAssistant",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "name": "description"
          },
          {
            "kind": "ScalarField",
            "name": "isVerified"
          },
          {
            "kind": "ScalarField",
            "name": "isFavourite"
          },
          {
            "kind": "ClientExtension",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__id"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "icon"
          },
          {
            "kind": "ScalarField",
            "name": "externalConfigReference"
          },
          {
            "kind": "ScalarField",
            "name": "identityAccountId"
          },
          {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isUser"
              },
              {
                "kind": "ScalarField",
                "name": "picture"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "appType"
                  }
                ],
                "type": "AppUser"
              },
              (v4/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "creatorType"
          },
          {
            "kind": "ScalarField",
            "name": "forgeCreator"
          },
          {
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "authoringTeam",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              (v4/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v7/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "YourAgentResultsQuery",
    "selections": [
      {
        "alias": "ownedAgents",
        "args": (v3/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v5/*: any*/)
      },
      {
        "alias": "starredAgents",
        "args": (v6/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v5/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "YourAgentResultsQuery",
    "selections": [
      {
        "alias": "ownedAgents",
        "args": (v3/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      {
        "alias": "starredAgents",
        "args": (v6/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": (v9/*: any*/)
      }
    ]
  },
  "params": {
    "id": "a274c95e5cb081e24500c5bedb48bc018cc724673947ee23ad2809b113ee93ee",
    "metadata": {},
    "name": "YourAgentResultsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8df4c3a25a728253ddf0b5d30b2d1c3c";

export default node;
